import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';

import NumberFormat from '@/components/NumberFormat';

const useStyles = makeStyles(() => ({
  gutterBottom: {
    margin: '0 0 20px',
  }
}))

function Attendance({ attendance, venue }) {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item className={classes.gutterBottom}>
        <ListItemText
          primary={`Game was played at the ${venue}.`}
          secondary={
            <>
              Attendance: <NumberFormat number={attendance.total.amount} /> ({attendance.total.pct}%)
            </>
          }
        />
      </Grid>
      <Grid container item direction="column">
        <Grid item>
          <Typography variant="h6">Breakdown</Typography>
        </Grid>
        <Grid item>
          <List>
            {attendance.sections.map(section => (
              <ListItem key={section.name}>
                <ListItemText
                  primary={section.name}
                  secondary={
                    <>
                      Attendance: <NumberFormat number={section.total} /> ({section.pct}%)
                    </>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Attendance;
